import api from "@/services/api";

const noAuthCfg = { _noAuthHeader: true };

const { get, post, put, patch } = api.getPrefixedMethods("auth");

export default {
  register(userInfo) {
    return post("register", userInfo, noAuthCfg);
  },
  login(userCreds) {
    return post("sign-in", userCreds, noAuthCfg);
  },
  refreshToken(data) {
    return post("sign-in/refresh", data, { _isRefreshTokenRequest: true });
  },
  logout() {
    return post("sign-out");
  },
  confirmEmail(user_id, otp) {
    return post(`activate/${user_id}/${otp}`, null, noAuthCfg);
  },
  completeRegistration(user_id, otp, userInfo) {
    return put(`complete-registration/${user_id}/${otp}`, userInfo, noAuthCfg);
  },
  passwordResetRequest(email) {
    return post("password_reset", { email }, noAuthCfg);
  },
  passwordReset(password, token) {
    return post("password_reset/confirm", { password, token }, noAuthCfg);
  },
  loginStep2(code) {
    return post("sign-in-step2", { code });
  },
  getInviteInfo(uidb64, token) {
    return get(`invite-info/${uidb64}/${token}`, noAuthCfg);
  },
  acceptInvite(uidb64, token, payload) {
    return put(`accept-invite/${uidb64}/${token}`, payload, noAuthCfg);
  },
  getSignature() {
    return get("user/signature");
  },
  getPreferences() {
    return get("user/preferences");
  },
  // Provider logins (LAM-5263): channel ("email" | "fax" | null) and/or the confirmed fax number.
  updatePreferences({ communicationPreference, fax } = {}) {
    return patch("user/preferences", {
      ...(communicationPreference !== undefined ? { communicationPreference } : {}),
      ...(fax !== undefined ? { fax } : {}),
    });
  },
  // signatureStrokes is sent alongside the image on purpose: the backend clears stored geometry
  // whenever the image is updated without it, so that the two can never describe different
  // signatures. Omitting it here would silently downgrade every save to the raster-only path.
  updateSignature(signature, signatureStrokes = null) {
    return patch("user/signature", { signature, signatureStrokes });
  },
};
